var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 218.9 219.2",
    style: {
      enableBackground: "new 0 0 218.9 219.2"
    },
    xmlSpace: "preserve",
    fill: "rgb(4, 76, 124)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,109.6C0,48.9,48.7,0.1,109.1,0c60.6-0.1,109.8,49,109.8,109.6c0,60.5-49.3,109.7-109.8,109.6 C48.6,219.1,0,170.2,0,109.6z M109.5,197.6c48.7-0.1,88-39.7,87.8-88.3c-0.2-48.5-39.5-87.8-87.9-87.9 c-48.4-0.1-88.2,39.7-88.1,88.2C21.3,158.2,61,197.8,109.5,197.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,131.9c37.1,0,73.6,0,110.2,0c-4,18.7-28.1,36.3-51.6,37.8C87.7,171.3,62.2,155.1,54,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,87.4c-3.1,3.2-6.7,6.9-10.8,11.2c-3.5-4-6.9-7.9-10.9-12.4c-3.9,4.6-7.2,8.7-10.8,12.9c-4.6-4.8-8.1-8.4-11.3-11.8 C60.5,80,68,72.6,75,65.5C81.9,72.4,89.4,79.8,97,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,85.1c-4.8,5.4-8.3,9.2-11.6,12.8c-4-3.9-7.7-7.4-11-10.7c7.6-7.5,15.1-15,22.4-22.3c7,7,14.4,14.4,22,22 c-3.6,3-7.5,6.3-12.1,10.2C151.5,94.4,148.2,90.3,144.1,85.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelight);
export default __webpack_public_path__ + "static/media/delight.2da2e0968cadbefcd464c2d9ddbf203c.svg";
export { ForwardRef as ReactComponent };